/* © 2026 Ahmad Zubair Sufizada (Zayn Builds). All rights reserved. Licensed for use on JDM Engine Supply Ltd.'s store only. Not to be copied, resold or reused without written permission. */
/* JDM Engine Supply — VIN checker. Decodes with NHTSA vPIC (free), matches against the store's own listings.
   Never guesses: 1 clean match = "fits"; overlap / trim-dependent / drivetrain-unknown = "call us"; nothing = "not in catalog".
   How it reads the JDM catalog (no special handles needed):
   - Years: the range in the product TITLE ("2009–2019 Toyota Corolla …", "2021-Present …", or one year "2016 …").
     If the title has no year, the 4-digit year tags are used.
   - Make: any make tag (Toyota, Honda, Lexus, Scion, …). A product can carry several makes (BRZ / FR-S / 86).
   - Models: the other plain tags (Camry, CR-V, "Optima / Magentis" = Optima + Magentis). A model tag only counts
     if that name also appears in the product title — this ignores stray tags (e.g. an MDX tag on an RDX listing).
   - Litres from the title ("2.4L"), Turbo / NA from the title, Engine vs Transmission from the product type.
   Known vPIC fixes (Sonata 2.4 GDI, Canada-only Rondo / Micra / Corolla model names) are kept in VIN_FIX / VIN_MODEL.
   Lexus: vPIC returns Model "ES" + series "350"; our tags are "ES350" — both shapes are tried. */
(function(){
  if (window.JdmVIN) return;
  var ROOT = (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', CAT = null, MAKES = ['hyundai','kia','toyota','audi','mini','volkswagen','bmw','honda','ford','nissan','lexus','lincoln','mercedes-benz','subaru','chevrolet','gmc','buick','acura','scion','mazda','mitsubishi','infiniti'];
  var SKIP = ['engine','transmission','jdm','kdm','edm','usdm','used-import','brand-new','remanufactured'];
  var MINI_BASE = { 'hardtop':'cooper', 'cooper':'cooper', 'cooper-hardtop':'cooper', 'cooper-convertible':'convertible', 'convertible':'convertible',
    'cooper-coupe':'coupe-roadster', 'cooper-roadster':'coupe-roadster', 'coupe':'coupe-roadster', 'roadster':'coupe-roadster',
    'clubman':'clubman', 'cooper-clubman':'clubman', 'countryman':'countryman', 'cooper-countryman':'countryman',
    'paceman':'paceman', 'cooper-paceman':'paceman' };
  // Confirmed vPIC data errors. vin8 = 8th VIN character (engine code). Only add rows verified against a second source.
  var VIN_FIX = [
    { make:'hyundai', model:'sonata', y1:2011, y2:2014, vin8:'C', disp:'2.4', engine:'Theta II 2.4 GDI', turbo:'No' }
  ];
  // Canada-only models vPIC can't name. prefix = first VIN characters. Only fills a BLANK Model; never overrides vPIC.
  var VIN_MODEL = [
    { make:'kia', prefix:'KNAH', y1:2014, y2:2017, model:'Rondo' },
    { make:'nissan', prefix:'3N1CK3', y1:2015, y2:2019, model:'Micra', setMake:'NISSAN' },   // Canada-only K13 Micra, Aguascalientes plant
    { make:'toyota', prefix:'5YF', y1:2014, y2:2021, model:'Corolla' }                     // Oct 9: Canadian Corolla, Blue Springs MS plant (Corolla only)
  ];
  // vPIC model name (slug) -> our model tag(s), only where the names differ. trim = word that must appear in vPIC Series/Trim.
  var ALIAS = {
    'toyota':        { 'scion-tc':[{make:'scion', model:'tc'}], 'scion-im':[{make:'scion', model:'im'}], 'scion-xb':[{make:'scion', model:'xb'}],
                       'scion-xd':[{make:'scion', model:'xd'}], 'scion-fr-s':[{make:'scion', model:'fr-s'}] },
    'audi':          { 'allroad':['a4-allroad'] },
    'subaru':        { 'impreza':[{model:'wrx', trim:'wrx'}] },
    'mercedes-benz': { 'c-class':[{model:'c300', trim:'300'}], 'e-class':[{model:'e300', trim:'300'}],
                       'glc-class':[{model:'glc300', trim:'300'}], 'slc-class':[{model:'slc300', trim:'300'}] }
  };
  function slug(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); }
  function store(k,v){ try{ if(v===undefined) return localStorage.getItem(k); localStorage.setItem(k,v);}catch(e){ return null; } }
  function cleanVin(v){ return String(v||'').toUpperCase().replace(/[^A-Z0-9]/g,'').replace(/O/g,'0').replace(/[IQ]/g, function(c){ return c==='I'?'1':'0'; }); }
  function addProducts(list){
    var nowY = new Date().getFullYear() + 1;
    (list||[]).forEach(function(p){
      var t = String(p.title||''), ts = '-'+slug(t)+'-', y1, y2;
      var m = /\b((?:19|20)\d{2})\s*[–—-]\s*((?:19|20)\d{2}|present)\b/i.exec(t);
      if (m){ y1 = +m[1]; y2 = /present/i.test(m[2]) ? nowY : +m[2]; }
      else if ((m = /\b((?:19|20)\d{2})\b/.exec(t))){ y1 = y2 = +m[1]; }
      var tagsRaw = (p.tags||[]).map(function(x){ return String(x); });
      if (!y1){
        var ys = tagsRaw.filter(function(x){ return /^(19|20)\d{2}$/.test(x); }).map(Number);
        if (!ys.length) return;
        y1 = Math.min.apply(null, ys); y2 = Math.max.apply(null, ys);
      }
      var makes = [], models = [];
      tagsRaw.forEach(function(raw){
        if (/^(19|20)\d{2}$/.test(raw)) return;
        var sl = slug(raw);
        if (MAKES.indexOf(sl)>-1){ makes.push(sl); return; }
        if (sl==='chevrolet-gmc-buick' || SKIP.indexOf(sl)>-1) return;
        raw.split('/').forEach(function(part){
          var ms = slug(part); if (!ms) return;
          // only trust a model tag that the title also names
          if (ts.indexOf('-'+ms+'-')>-1 || ts.indexOf('-'+ms.replace(/-/g,'')+'-')>-1) models.push(ms);
        });
      });
      if (!makes.length || !models.length) return;
      var d = /(\d\.\d)\s?L/i.exec(t);
      var turbo = /Non-Turbo/i.test(t) ? false : (/\bNA\b/.test(t) && /Turbo/i.test(t) ? null : (/Turbo|T-GDI|DIT/i.test(t) ? true : (/\bNA\b/.test(t) ? false : null)));
      var kind = (/transmission/i.test(p.product_type||'') || /Transmission/.test(t)) ? 'trans' : 'engine';
      makes.forEach(function(make){
        CAT.push({ h:p.handle, y1:y1, y2:y2, make:make, models:models, disp:d?+d[1]:null, turbo:turbo, kind:kind,
          fwd: /\bFWD\b/.test(t), awd: /\bAWD\b/.test(t), trimnote: /EX \/ SX/.test(t) });
      });
    });
  }
  function loadCatalog(){
    if (CAT) return Promise.resolve(CAT);
    var acc = [];
    function page(n){
      return fetch(ROOT+'products.json?limit=250&page='+n).then(function(r){ return r.json(); }).then(function(j){
        var ps = j.products||[]; acc = acc.concat(ps);
        return (ps.length===250 && n<8) ? page(n+1) : acc;
      });
    }
    return page(1).then(function(all){ CAT = []; addProducts(all); return CAT; });
  }
  function fixDecode(vin, d){
    var yr = parseInt(d.ModelYear,10)||0, mk = slug(d.Make), md = slug(d.Model), c8 = vin.charAt(7);
    if (!md) VIN_MODEL.forEach(function(f){
      if ((f.make===mk || (!mk && f.setMake)) && vin.indexOf(f.prefix)===0 && f.y1<=yr && yr<=f.y2){
        d.Model = f.model; md = slug(f.model); if (!mk && f.setMake){ d.Make = f.setMake; mk = slug(f.setMake); }
      }
    });
    VIN_FIX.forEach(function(f){
      if (f.make===mk && f.model===md && f.y1<=yr && yr<=f.y2 && f.vin8===c8){
        d.DisplacementL = f.disp; d.EngineModel = f.engine; d.OtherEngineInfo = ''; d.Turbo = f.turbo;
      }
    });
    return d;
  }
  function decode(vin){
    return fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/'+vin+'?format=json')
      .then(function(r){ return r.json(); }).then(function(j){ return fixDecode(vin, (j.Results||[])[0]||{}); });
  }
  function match(d){
    var yr = parseInt(d.ModelYear,10)||0, mk = slug(d.Make), md = slug(d.Model);
    var disp = Math.round((parseFloat(d.DisplacementL)||0)*10)/10;
    var em = (d.EngineModel||'')+' '+(d.OtherEngineInfo||'');
    var turbo = d.Turbo==='Yes' || /t-gdi|turbo|ecoboost/i.test(em);
    function norm(s){ return slug(String(s||'').replace(/(\d)([a-z])/gi,'$1-$2').replace(/([a-z])(\d)/gi,'$1-$2')); }
    var trimTok = norm((d.Trim||'')+' '+(d.Series||'')+' '+(d.Trim2||'')+' '+(d.Series2||'')).split('-');
    function trimHas(w){ return norm(w).split('-').every(function(t){ return trimTok.indexOf(t)>-1; }); }
    var cands = [{make:mk, model:md}];
    ((ALIAS[mk]||{})[md]||[]).forEach(function(a){
      if (typeof a==='string') a = {model:a};
      if (a.trim && !trimHas(a.trim)) return;
      cands.push({make:a.make||mk, model:a.model});
    });
    var hybrid = /HEV/i.test(d.ElectrificationLevel||'') || /hybrid/i.test(d.Model||'');
    // Lexus-style names: vPIC Model "ES" + series "350" -> our tag "es350" (also "ct200h", "hs250h")
    if (mk==='lexus' && md && md.length<=3){
      var num = String((d.Series||'')+' '+(d.Trim||'')).match(/\b(\d{3})\s*(h|t)?\b/i);
      if (num) cands.push({make:mk, model: md+num[1]+(num[2]?num[2].toLowerCase():'')});
      if (disp){ var dn = String(Math.round(disp*100)); cands.push({make:mk, model: md+dn}); cands.push({make:mk, model: md+dn+'h'}); }
    }
    var dt = String(d.DriveType||'').toUpperCase(), awd = /AWD|4WD|4X4|ALL/.test(dt), fwd = /FWD|FRONT|4X2/.test(dt);
    if (!yr || !mk) return { status:'nodecode', list:[] };
    var mini = mk==='mini', miniBoth = false;
    if (mini){
      var base = MINI_BASE[md], ser = '-'+slug((d.Series||'')+' '+(d.Trim||''))+'-';
      if (base){
        if (/-john-cooper-works-|-jcw-/.test(ser)) md = base+'-jcw';        // JCW not listed -> never sold as S
        else if (/-cooper-s-/.test(ser)) md = base+'-s';
        else if (/-cooper-/.test(ser)) md = base;
        else { md = base; miniBoth = true; }                                 // series blank -> S or not unknown -> call
      }
    }
    var maybe = {};   // handle -> true when base model + year fit but vPIC did not confirm the trim
    function mm(p){
      if (mini) return p.make===mk && (p.models.indexOf(md)>-1 || (miniBoth && p.models.indexOf(md+'-s')>-1));
      for (var c=0;c<cands.length;c++){
        var cm = cands[c].model; if (p.make!==cands[c].make || !cm) continue;
        for (var i=0;i<p.models.length;i++){
          var m = p.models[i];
          if (m===cm) return true;
          if (m.indexOf(cm+'-')===0){
            var rest = m.slice(cm.length+1).split('-');
            if (rest.join('-')==='v6' && disp>=3) return true;
            if (rest.join('-')==='hybrid' && hybrid) return true;
            if (trimHas(rest.join(' '))) return true;
            maybe[p.h] = true;
          }
          if (cm.indexOf(m+'-')===0) return true;
        }
      }
      return false;
    }
    var exact = (CAT||[]).filter(function(p){ return p.y1<=yr && yr<=p.y2 && mm(p); });
    exact = exact.filter(function(p, idx){ return exact.findIndex(function(q){ return q.h===p.h; })===idx; });
    if (!exact.length){
      var mb = (CAT||[]).filter(function(p){ return maybe[p.h] && p.y1<=yr && yr<=p.y2 && (!disp || p.disp===null || Math.abs(p.disp-disp)<0.15); });
      if (mb.length) return { status:'call', list:mb };   // trim-specific listing, trim unconfirmed -> call us, never "not stocked"
    }
    var c = exact;
    if (disp) c = c.filter(function(p){ return p.disp===null || Math.abs(p.disp-disp)<0.15; });
    var eng = c.filter(function(p){ return p.kind==='engine'; });
    var tset = {}; eng.forEach(function(p){ tset[String(p.turbo)]=1; });
    if (!miniBoth && eng.length>1 && Object.keys(tset).length>1){ var e2 = eng.filter(function(p){ return p.turbo===turbo; }); if (e2.length) eng = e2; }
    var call = eng.length>1 || eng.some(function(p){ return p.trimnote; });
    var tr = c.filter(function(p){ return p.kind==='trans'; }).filter(function(p){
      if ((p.fwd && awd) || (p.awd && fwd)) return false;
      if ((p.fwd || p.awd) && !(awd || fwd)) call = true;
      return true;
    });
    // Guard: we list this exact vehicle + year, but NHTSA's litres match none of our engines for it -> don't trust NHTSA.
    var exactEng = exact.filter(function(p){ return p.kind==='engine'; });
    if (disp && !eng.length && exactEng.length) return { status:'check', list:exactEng.concat(tr) };
    var list = eng.concat(tr);
    if (!list.length){
      // Near miss: same make + model + litres, year within 1 of a listing -> "call us, we may have it". Engines only.
      var n = (CAT||[]).filter(function(p){ return p.kind==='engine' && p.y1-1<=yr && yr<=p.y2+1 && mm(p) && (!disp || p.disp===null || Math.abs(p.disp-disp)<0.15); });
      var nt = {}; n.forEach(function(p){ nt[String(p.turbo)]=1; });
      if (!miniBoth && n.length>1 && Object.keys(nt).length>1){ var n2 = n.filter(function(p){ return p.turbo===turbo; }); if (n2.length) n = n2; }
      if (n.length) return { status:'near', list:n };
      return { status:'none', list:[] };
    }
    return { status: call ? 'call' : 'fits', list:list };
  }
  function vehicleName(d, noDisp){
    var model = d.Model;
    if (slug(d.Make)==='mini' && d.Series){
      var body = String(d.Model||'').replace(/^Cooper\s*/i,'').replace(/^Hardtop$/i,'');
      model = d.Series + (body ? ' '+body : '');
    }
    return [d.ModelYear, d.Make && d.Make.charAt(0)+d.Make.slice(1).toLowerCase(), model, (!noDisp && d.DisplacementL) ? (Math.round(parseFloat(d.DisplacementL)*10)/10).toFixed(1)+'L' : ''].filter(Boolean).join(' ');
  }
  function money(c, cur){ try { return new Intl.NumberFormat('en-CA',{style:'currency',currency:cur||'CAD',maximumFractionDigits:0}).format(c/100); } catch(e){ return '$'+Math.round(c/100); } }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function setCartVin(vin){ try { fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{VIN:vin}})}); } catch(e){} }
  function injectFormVin(vin, scope){
    (scope||document).querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
      var i = f.querySelector('input[name="properties[VIN]"]');
      if (!i){ i = document.createElement('input'); i.type='hidden'; i.name='properties[VIN]'; f.appendChild(i); }
      i.value = vin;
    });
  }

  function init(root){
    if (root.dataset.vinInit) return; root.dataset.vinInit = '1';
    var T = JSON.parse(root.querySelector('[data-vin-strings]').textContent);
    if (!T.check) T.check = "We need to confirm your engine size. Call or text us with your VIN and we'll check the right engine:";
    var mode = root.dataset.mode, handle = root.dataset.handle, rootUrl = root.dataset.root || '/'; ROOT = rootUrl;
    var form = root.querySelector('[data-vin-form]'), input = root.querySelector('[data-vin-input]'), out = root.querySelector('[data-vin-out]'), btn = root.querySelector('[data-vin-btn]');
    root.hidden = false;
    var qs = new URLSearchParams(location.search).get('vin'), saved = store('jdmVin');
    if (qs || saved) input.value = cleanVin(qs || saved);
    function show(html, cls){ out.className = 'evin__out ' + (cls||''); out.innerHTML = html; out.hidden = false; }
    function callLine(){ return '<div class="evin__calls"><a class="evin__call" href="tel:+14034717150">'+esc(T.call)+'</a><a class="evin__call evin__call--text" href="sms:+14034717150?&body='+encodeURIComponent('VIN check: '+input.value)+'">'+esc(T.text||'Text us')+'</a></div>'; }
    function card(p, info){
      return '<a class="evin__item" href="'+esc(info.url)+'?vin='+esc(input.value)+'">'+
        (info.featured_image ? '<img src="'+esc(info.featured_image)+'&width=160" alt="" width="64" height="64" loading="lazy">' : '')+
        '<span><b>'+esc(info.title)+'</b><small>'+money(info.price)+'</small></span><i aria-hidden="true">›</i></a>';
    }
    function run(){
      var vin = cleanVin(input.value); input.value = vin;
      if (vin.length !== 17){ show('<p>'+esc(T.len)+'</p>', 'is-warn'); return; }
      btn.disabled = true; show('<p>'+esc(T.loading)+'</p>', 'is-load');
      Promise.all([decode(vin), loadCatalog()]).then(function(r){
        var d = r[0], res = match(d), veh = vehicleName(d, res.status==='check');
        btn.disabled = false;
        if (res.status==='nodecode'){ show('<p><b>'+esc(T.nodecode)+'</b></p>'+callLine(), 'is-warn'); return; }
        store('jdmVin', vin); setCartVin(vin);
        var hereAny = mode==='product' && res.status!=='near' && res.list.some(function(p){ return p.h===handle; });
        if (hereAny) injectFormVin(vin, root.closest('.product-section, [data-section-type], .shopify-section') || document);
        var head = '<p class="evin__veh">'+esc(T.vehicle)+' <b>'+esc(veh)+'</b></p>';
        if (res.status==='none'){ show(head+'<p><b>'+esc(T.none)+'</b></p>'+callLine(), 'is-warn'); return; }
        if (mode==='product' && res.status!=='near'){
          var here = res.list.some(function(p){ return p.h===handle; });
          if (here && res.status==='fits'){ show(head+'<p class="evin__ok"><b>'+esc(T.fitsThis)+'</b></p><p class="evin__small">'+esc(T.saved)+'</p>', 'is-ok'); return; }
          if (here){ show(head+'<p><b>'+esc(res.status==='check' ? T.check : T.callThis)+'</b></p>'+callLine(), 'is-warn'); return; }
        }
        Promise.all(res.list.map(function(p){ return fetch(rootUrl+'products/'+p.h+'.js').then(function(r){ return r.json(); }).catch(function(){ return null; }); })).then(function(infos){
          var cards = res.list.map(function(p,i){ return infos[i] ? card(p, infos[i]) : ''; }).join('');
          var msg = res.status==='near' ? T.near : (res.status==='check' ? T.check : (res.status==='fits' ? (mode==='product' ? T.notThis : T.fits) : T.callMany));
          show(head+'<p><b>'+esc(msg)+'</b></p><div class="evin__list">'+cards+'</div>'+(res.status!=='fits' ? callLine() : (mode==='product' ? '' : '<p class="evin__small">'+esc(T.saved)+'</p>')), res.status==='fits' && mode!=='product' ? 'is-ok' : 'is-warn');
        });
      }).catch(function(){ btn.disabled = false; show('<p><b>'+esc(T.offline)+'</b></p>'+callLine(), 'is-warn'); });
    }
    form.addEventListener('submit', function(e){ e.preventDefault(); run(); });
    if (qs && mode==='product') run();
  }
  window.JdmVIN = { init:init, _match:match, _load:loadCatalog, _fix:fixDecode, _add:function(l){ CAT = CAT || []; addProducts(l); return CAT; } };
  function boot(){ document.querySelectorAll('[data-jdm-vin]').forEach(init); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
